import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiAdminPost } from "../../lib/api";
import { getAdminPassword, setAdminPassword } from "../../lib/adminSession";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Đã đăng nhập trong session này rồi thì vào thẳng
    if (getAdminPassword()) navigate("/admin/tools", { replace: true });
  }, [navigate]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!password.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const res = await apiAdminPost<null>("/api/v1/tools/verify", password, undefined);
      if (!res.success) {
        setError(res.error ?? "Sai mật khẩu");
        return;
      }
      setAdminPassword(password);
      navigate("/admin/tools", { replace: true });
    } catch {
      setError("Không kết nối được máy chủ");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={handleSubmit} className="glass-card w-full max-w-sm space-y-4">
        <h1 className="text-xl font-bold">Đăng nhập quản trị</h1>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mật khẩu"
          className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#72aaff]"
        />
        {error && <p className="text-red-400 text-sm">{error}</p>}
        <button
          type="submit"
          disabled={loading || !password.trim()}
          className="btn-gradient w-full disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Đang kiểm tra..." : "Đăng nhập"}
        </button>
      </form>
    </div>
  );
}
